import { useEffect, useState } from "react";
import { Card, Table, Tooltip } from "antd";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import useApiData from "components/common/useGetApiData";
import { getDayWiseAttendance } from "hooks/api/attendanceApi/dayWiseAttendanceApi";
import { EMPLOYEE_ATTENDANCE_DAILY } from "constants";
import dayjs from "dayjs";
import { EmployeeDetails } from "components/common/CommonComponent";
import { ImagePaths } from "utils/ImagePath";
import IconButton from "components/ui/Button/IconButton";
import AttendanceFilter from 'pages/attendance/AttendanceFilters';
import EditDayWiseAttendance from "./EditDayWiseAttendance";
// import { checkUserPermissionFunc } from "components/common/CommonFuntion";
import { formatTime12Hour, formatTimeSpan } from 'components/common/validation';
import useApiMethods from "hooks/apiConfig/method/apiMethods";
import { NEW_EMPLOYEE_ATTENDANCE_DAILY } from "constant";

const initialData = {
    employee_name: "",
    designation_name: "",
    department_name: "",
    status: ""
}

function DaywiseAttendance() {
    const query = "";
    const pageSize = 10;
    const dateFormat = "YYYY-MM-DD";
    const authtoken = sessionStorage.getItem("token");
    const date = new Date().toLocaleDateString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('/').reverse().join('-');

    const [editVisible, setEditVisible] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [sorting, setSorting] = useState("");
    const [selectedDetails, setSelectedDetails] = useState({});
    const [dataUpdated, setDataUpdated] = useState(false);
    const [filterVisible, setFilterVisible] = useState(false);
    const [filterDatas, setFilterDatas] = useState({ initialData });
    const [reorderedColumns, setReorderedColumns] = useState([]);
    const [selectedDate, setSelectedDate] = useState(dayjs(date, dateFormat));
    const tableContainerHeight = "72vh";
    const is_super_admin = JSON.parse(sessionStorage.getItem("is_super_admin"));
    const is_admin = JSON.parse(sessionStorage.getItem("is_admin"));
  
    let isEditAccess = (is_super_admin || is_admin);

    useEffect(() => {
        if (!authtoken) {
            window.location.href = "/";
        }
    }, [authtoken]);

    // const userPermission = checkUserPermissionFunc("attendance", "Day wise Attendance", "SubMenu");
    
    const queryString =
        "?page_no=" + pageNo +
        "&page_size=" + pageSize +
        "&employee_id=" + (filterDatas.employee_name ? filterDatas.employee_name : "") +
        "&designation=" + (filterDatas.designation_name ? filterDatas.designation_name : "") +
        "&department=" + (filterDatas.department_name ? filterDatas.department_name : "") +
        "&status=" + (filterDatas.status ? filterDatas.status : "") +
        "&search=" + searchText + (sorting ? `&${sorting}` : "") +
        "&date=" + (selectedDate ? dayjs(selectedDate).format(dateFormat): "");

    // const [data, pageInfo, loading, _message, refetch] = useApiData(getDayWiseAttendance, {
    //     pageNo,
    //     pageSize,
    //     queryString,
    //     searchText,
    //     sorting,
    //     date
    // });

    
  const { fetch, update } = useApiMethods();
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [filter, setFilter]=useState({pageNo:'', pageSize:'', query:'', search:'', sorting:''})

  const fetchAttendanceWiseData = async () => {        
    const res = await fetch(
      NEW_EMPLOYEE_ATTENDANCE_DAILY, 
      filter,
      setLoading
    );
    if (res?.status) {
      setData(res.data.result);
      setPageInfo({
        pageNo: res.data.page_no,
        pageSize: res.data.page_size,
        totalCount: res.data.total_count,
        noOfPages: res.data.no_of_pages,
      });
    }
  };

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
    fetchAttendanceWiseData();
  }, [filter, editVisible]);


    const handleEditClick = (details) => {
        setSelectedDetails(details);
        if (editVisible && Object.keys(selectedDetails).length > 0) {
            ToastMsg("warning", "Please cancel the existing edit operation!")
        }
        else if (!editVisible) {
            setEditVisible(true);
            setSelectedDetails(details);
        }
    };

    const handleSearch = () => {
        setPageNo(1);
        setFilter((prevFilter) => ({
            ...prevFilter, 
            pageNo: 1, 
            pageSize: pageSize || prevFilter.pageSize, 
            query: queryString,
            search: searchText,
            sorting: sorting,
          }));
        setDataUpdated(!dataUpdated);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
        const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : "";
        setFilter((prevFilter) => ({
          ...prevFilter, 
          pageNo: pagination.current, 
          pageSize: pagination.pageSize || prevFilter.pageSize, 
          query: queryString, 
          sorting: sortQuery,
        }));
        setSorting(sortQuery)
      }
    
    useEffect(() => {
        const newQuery = `employee_id=${filterDatas.employee_name || ""}`
            + `&designation=${filterDatas.designation_name || ""}`
            + `&department=${filterDatas.department_name || ""}`
            + `&status=${filterDatas.status || ""}`
            + `&search=${searchText}`
            + `&date=${dayjs(selectedDate).format(dateFormat)}`
            + (sorting ? `&${sorting}` : "");
    
        setFilter((prevFilter) => ({
            ...prevFilter,
            query: newQuery,
        }));
    }, [filterDatas]);
    

    // Date changes start 
    let dateString = date

    // Filter the data based on the selected date
    const handleDateChange = (date) => {
        setSelectedDate(date);
        dateString = dayjs(date).format(dateFormat)
        setFilterDatas({ ...filterDatas, date: dateString });
        setDataUpdated(!dataUpdated);
    };
    // Date changes end

    // filter start
    const renderFilter = (data) => {
        setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
        setPageNo(1);
        setFilterVisible(false);
    }

    const ClosePopUp = () => {
        setFilterVisible(false);
    }

    const clearFilter = () => {
        setFilterDatas(initialData);
        setPageNo(1);
    }
    //filter end

    const columns = [
        {
            title: "Employee Details",
            dataIndex: "id",
            key: "name",
            width: "15dvw",
            sorter: true,
            fixed: "left",
            render: (_, record) => {
                let { employee_details } = record;
                let empDetails = {
                    ...record,
                    title: employee_details.title ? employee_details.title : "",
                    first_name: employee_details.employee_name ? employee_details.employee_name : "",
                    last_name: "",
                    designation_id: {
                        id: employee_details?.designation?.id ? employee_details?.designation?.id : "",
                        designation_name: employee_details?.designation?.name ? employee_details?.designation?.name : ""
                    },
                    id: employee_details.employee_id,
                    profile: employee_details.profile,
                }
                return ( <span style={{ color: record.is_active ? "black" : "#CACACA", cursor: "pointer" }}>
                        <EmployeeDetails is_active ={record?.is_active} details={empDetails} /></span>)
            }
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            sorter: true,
            width: "8dvw",
            render: (_, record) => {
                let colors = record?.is_active ? "black" : "#CACACA";
                <span style={{ color: colors }}>{record.date ? dayjs(record.date, "YYYY-MM-DD").format("DD-MM-YYYY") : "-"}</span>
            },
            align: "center",
        },
        {
            title: "Shift",
            dataIndex: "shift",
            key: "shift",
            sorter: true,
            width: "8dvw",      
            render: (_, record) =>
            {   
                let colors = record?.is_active ? "black" : "#CACACA";
                return (
                    record?.shift?.length > 15 ?
                    <Tooltip title={record?.shift}>{<span>{record?.shift?.slice(0, 14) + "..."}</span>}</Tooltip>
                    : <p style={{ color: colors }}>{record?.shift ? record?.shift : "-"}</p>
                )
            }
        },
        {
            title: "Clock In Location",
            dataIndex: "location",
            key: "location",
            sorter: true,
            width: "11dvw",
            render: (_, record) =>{
                let colors = record?.is_active ? "black" : "#CACACA";
                record?.location?.length > 28 ?
                <Tooltip title={record?.location}>{<span style={{ color: "black" }}>{record?.location?.slice(0, 25) + "..."}</span>}</Tooltip>
                : <p style={{ color: colors }}>{record?.location ? record?.location : "-"}</p>
            }
        },
        {
            title: "Clock Out Location",
            dataIndex: "location",
            key: "location",
            sorter: true,
            width: "11dvw",
            render: (_, record) =>
            (record?.clockout_location?.length > 15 ?
                <Tooltip title={record?.clockout_location}>{<span>{record?.clockout_location?.slice(0, 14) + "..."}</span>}</Tooltip>
                : <p>{record?.clockout_location ? record?.clockout_location : "-"}</p>)
        },
        {
            title: "Check In",
            dataIndex: "check_in",
            key: "check_in",
            sorter: true,
            width: "8dvw",      
            render: (_, record) => {
                let colors = record?.is_active ? "black" : "#CACACA";
                return (<p style={{ color: colors }}>{(record?.check_in && record?.check_in !== "NaT") ? formatTime12Hour(record?.check_in) : "00:00"}</p>)
            }
        },
        {
            title: "Check Out",
            dataIndex: "check_out",
            key: "check_out",
            sorter: true,
            width: "8dvw",      
            render: (_, record) => {
                let colors = record?.is_active ? "black" : "#CACACA";
                return (<p  style={{ color: colors }}>{(record?.check_out && record?.check_out !== "NaT") ? formatTime12Hour(record?.check_out) : "00:00"}</p>)
            }
        },
        {
            title: "Overtime",
            dataIndex: "overtime",
            key: "overtime",
            sorter: true,
            width: "8dvw",      
            render: (_, record) => (<span>{(record.overtime && record?.overtime !== "NaT")  ? formatTimeSpan(record.overtime): "-"}</span>),
        },

        {
            title: "Break Hours",
            dataIndex: "break_hrs",
            key: "break_hrs",
            width: "9dvw",
            sorter: true,
            render: (_, record) => {
            let colors = record?.is_active ? "black" : "#CACACA";
            <span style={{ color: colors }}>{(record.break_hrs && record?.break_hrs !== "NaT") ? formatTimeSpan(record.break_hrs)  : "-"}</span>},
        },
        {
            title: "Total Working Hours",
            dataIndex: "total_working_hours",
            key: "total_working_hours",
            sorter: true,
            width: "12dvw",
            render: (_, record) => {
                let colors = record?.is_active ? "black" : "#CACACA";
                <span style={{ color: colors }}>{(record.total_working_hours && record?.total_working_hours !== "NaT") ? formatTimeSpan(record.total_working_hours)  : "-"}</span>
              },
        }
    ];

    if (isEditAccess) {
        columns.push({
            title: "Action",
            key: "action",
            align: 'center',
            width: "7dvw",
            fixed: "right",
            render: (_, record) => (
                <IconButton
                    title="Edit"
                    icon={<img src={ImagePaths.edit.default} alt="Edit" />}
                    onClick={() => (loading ? "" : handleEditClick(record))}
                />
            ),
        })
    }

    const handleFilter = () => {
        setFilterVisible(true)
    }

    const handleSave = () => {
        setEditVisible(false);
        setSelectedDetails({});
        setFilter((prevFilter) => ({
            ...prevFilter, 
            pageNo: 1, 
            pageSize: pageSize || prevFilter.pageSize, 
            query: queryString,
            search: searchText,
            sorting: sorting,
          }));
        setDataUpdated(!dataUpdated);
    };

    const handleCancel = () => {
        setEditVisible(false);
        setSelectedDetails({});
    };

    const handleStateChanges = (search = "", reorderedList = []) => {
        setSearchText(search)
        setReorderedColumns(reorderedList)
    }

    const printData =
        "?page_no=" + pageNo +
        "&page_size=" + pageSize +
        "&employee_id=" + (filterDatas.employee_name ? filterDatas.employee_name : "") +
        "&designation=" + (filterDatas.designation_name ? filterDatas.designation_name : "") +
        "&department=" + (filterDatas.department_name ? filterDatas.department_name : "") +
        "&status=" + (filterDatas.status ? filterDatas.status : "") +
        "&search=" + searchText + (sorting ? `&${sorting}` : "") +
        "&date=" + (selectedDate ? dayjs(selectedDate).format(dateFormat): "");

    const styles = {
        fltContainer: {
            border: "1px solid #cbcbcb",
            height: tableContainerHeight,
        },
    }

    return (
        <Card className="h-full overflow-hidden">
            <div className={"h-1/6"} >
                <CommonTblHeader pageName={"Day-wise Attendance"}
                    pageInfo={pageInfo}
                    handleSearch={handleSearch}
                    onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
                    url={NEW_EMPLOYEE_ATTENDANCE_DAILY} query={printData}
                    isAddRequired={false} isDraftRequired={false}
                    isDateRequired={true} handleDateChange={handleDateChange} selectedDate={selectedDate}
                />
            </div>
            <div className="h-5/6 flex justify-center items-center  mt-1">
                {filterVisible ?
                    <div className="w-1/4 mt-5" style={styles.fltContainer}>
                        <AttendanceFilter
                            pageName={"DaywiseAttendance"}
                            filterDatas={filterDatas}
                            closeFilter={ClosePopUp}
                            filteredData={renderFilter}
                            clearData={clearFilter} />
                    </div>
                    : null}
                <div className={filterVisible ? "mt-5 w-3/4" : "mt-5 w-full"} style={styles.fltContainer}>
                <Table 
                    columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
                    dataSource={data?.length > 0 ? data : null}
                    loading={loading}
                    style = {{"--table-container-height": tableContainerHeight}}
                    scroll={{ y: `calc(${tableContainerHeight} - 190px)` }}
                    onChange={handleTableChange}
                    pagination={{
                        style: { marginRight: 20, padding: 0 },
                        defaultPageSize: pageSize,
                        showSizeChanger: false,
                        showQuickJumper: true,
                        total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
                        pageSizeOptions: ["10", "20", "30"],
                        pageSize,
                        defaultCurrent: pageNo,
                    }}
                    key={dataUpdated ? "updated" : "not-updated"}
                />
                </div>
            </div>
            {(editVisible && Object.keys(selectedDetails).length > 0) ?
                <EditDayWiseAttendance
                    editDetails={selectedDetails}
                    onHide={handleCancel}
                    onSave={handleSave}
                    fromEdit={editVisible}
                />
                : null}
        </Card>
    );
}

export default DaywiseAttendance;
